import { TemplateStepValues, RecipientsStepValues } from './schema';

export enum GenerateContractFormStepName {
    Templates = 'templates',
    Recipients = 'recipients',
}

export enum RecipientsFormFields {
    Recipients = 'recipients',
    Email = 'email',
    Deadline = 'deadline',
}

export enum RecipientsFieldName {
    Name = 'name',
    Email = 'email',
}

export type GenerateContractFormValues = TemplateStepValues & RecipientsStepValues;
